import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaSnapchatGhost,
  FaGoogle,
} from "react-icons/fa";
import { Compass } from "lucide-react";

// Brand colors — authentic platform palette, tuned for dark backgrounds
export const BRAND_COLORS = {
  facebook: "#1877F2",
  instagram: "#E1306C", // feed pink
  tiktok: "#25F4EE", // cyan (we shadow with magenta via glow)
  youtube: "#FF3B30",
  snapchat: "#FFFC00",
  google: "#4285F4",
  consulting: "#A78BFA", // violet family for brand continuity
};

export const BRAND_GLOW = {
  facebook: "rgba(24,119,242,0.45)",
  instagram: "rgba(225,48,108,0.45)",
  tiktok: "rgba(254,44,85,0.45)",
  youtube: "rgba(255,59,48,0.45)",
  snapchat: "rgba(255,252,0,0.35)",
  google: "rgba(66,133,244,0.45)",
  consulting: "rgba(124,58,237,0.45)",
};

export const ServiceIcon = ({ iconKey, className = "h-6 w-6", colored = false }) => {
  const color = colored ? BRAND_COLORS[iconKey] : undefined;
  const style = color ? { color } : undefined;

  switch (iconKey) {
    case "facebook":
      return <FaFacebookF className={className} style={style} />;
    case "instagram":
      return <FaInstagram className={className} style={style} />;
    case "tiktok":
      return <FaTiktok className={className} style={style} />;
    case "youtube":
      return <FaYoutube className={className} style={style} />;
    case "snapchat":
      return <FaSnapchatGhost className={className} style={style} />;
    case "google":
      return <FaGoogle className={className} style={style} />;
    case "consulting":
      return <Compass className={className} style={style} />;
    default:
      return null;
  }
};
